import { createFileRoute } from '@tanstack/react-router';
import { TaskLabelsPage } from '@/features/tasks/admin/TaskLabelsPage';

/**
 * Anagrafica delle etichette dei task. Il componente sta in `features/tasks/admin/` accanto a
 * `WorkflowsPage`, che è l'altra configurazione dello stesso dominio — e perché una pagina dentro un
 * file di rotta non si può montare in un test senza finta del router.
 */
export const Route = createFileRoute('/_app/admin/task-labels')({ component: TaskLabelsPage });
